<template>
  <el-row type="flex" justify="space-between">
    <el-col :span="16">
      <p class="title"><strong>{{ label }} List</strong></p>
      <div class="se-list"
           v-loading="loading"
           element-loading-text="Loading...">
        <div class="se-item header">
          <div class="se-info-item name">Name</div>
          <div class="se-info-item name" v-role=[1,2,3,13]>Type</div>
          <div class="se-info-item city">Province</div>
          <div class="se-info-item city">City</div>
          <div class="se-info-item hospital">Hospital</div>
          <div class="se-info-item department">Department</div>
          
          <!--    <div class="se-info-item status">
                Status
              </div>
              <div class="se-info-item comment">Adandam</div>
              <div class="se-info-item submit-date">
                Submitted Date
              </div>
              <div class="se-info-item push-date">
                Pushed Date
              </div>-->
        </div>
        <div class="empty" v-if="list.length===0">
          <p>No Data</p>
        </div>
        <div
          v-else
          class="se-item"
          v-for="item in list" :key="item.SEID">
          <div class="se-info-item name">{{ item.Name }}</div>
          <div class="se-info-item name" v-role=[1,2,3,13] >{{ item.Type }}</div>
          <div class="se-info-item city">{{ item.Province }}</div>
          <div class="se-info-item city">{{ item.City }}</div>
          <div class="se-info-item hospital">{{ item.Hospital }}</div>
          <div class="se-info-item department">{{ item.Department }}</div>
          <!--    <div class="se-info-item status">
                <el-tag type="success" v-if="item.status">Pushed</el-tag>
                <el-tag type="danger" v-else>Failed</el-tag>
              </div>
              <div class="se-info-item comment">{{ item.comment }}</div>
              <div class="se-info-item submit-date">
                {{ item.submitDate }}
              </div>
              <div class="se-info-item push-date">
                {{ item.pushDate }}
              </div>-->
        </div>
      </div>
    </el-col>
    <el-col :span="6">
      <p class="title"><strong>Request Info</strong></p>
      <p class="request-info" v-html="requestInfo"></p>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "expand-for-draft",
  props: {
    label: String,
    batchId: String,
    requestInfo: String
  },
  data() {
    return {
      loading: true,
      list: []
    }
  },
  mounted() {
    this.getSEList();
  },
  methods: {
    getSEList() {
      this.loading = true;
      this.axios.get("/push/batchSeList", {
        params: {
          batchId: this.batchId
        }
      }).then(({code, data}) => {
        this.loading = false;
        if (200 === code) {
          this.list = data;
        }
      }).catch(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped lang="scss">
p {
  line-height: 24px;

  &.title {
    font-size: 14px;
    color: #000;
    line-height: 30px;
  }

  &.request-info {
    margin-top: 5px;
  }
}

.empty p {
  line-height: 60px;
  text-align: center;
  color: #a9a9a9;
}

.se-list {
  .se-item {
    display: flex;

    &.header {
      font-weight: bold;
    }

    &:not(:last-child) {
      border-bottom: 1px solid #ebeef5 !important;
    }
  }

  .se-info-item {
    padding-right: 10px;
    line-height: 30px;

    &.name {
      padding-left: 0;
      width: 10vw;
    }

    &.city {
      width: 12vw;
    }

    &.hospital {
      width: 20vw;
    }

    &.department {
      width: 15vw;
    }

    &.status {
      width: 72px;
    }

    &.comment {
      width: 25vw;
    }

    &.submit-date,
    &.push-date {
      width: 180px;
    }

    &.push-date {
      padding-right: 0;
    }
  }
}
</style>